module.exports = __webpack_public_path__ + "img/filters-all-img.e80a7d2c.svg";